
const ServicesOverviewSection = () => {
  const services = [
    {
      icon: "ri-shield-check-line",
      title: "Occupational Health & Safety Consulting",
      description: "Comprehensive safety consulting services including staff training, construction safety inspections, and compliance with OSHA, state, local, and government agency requirements."
    },
    {
      icon: "ri-team-line",
      title: "Full-Time Safety Services",
      description: "Complete safety program management including inspections, safety meetings, accident investigations, compliance reviews, audits, hazard identification, and workers' exposure monitoring."
    },
    {
      icon: "ri-leaf-line",
      title: "Environmental Consulting",
      description: "Development and management of environmental programs in construction, including ambient air monitoring, spill prevention, hazardous waste handling, storage, transportation, and disposal."
    },
    {
      icon: "ri-air-balloon-line",
      title: "Air Monitoring Services",
      description: "Worker exposure personal and area air monitoring services with certified industrial hygienists available for specialized projects and assessments."
    },
    {
      icon: "ri-paint-brush-line",
      title: "Quality Control for Industrial Coatings",
      description: "Comprehensive quality control services for industrial coating operations with certified inspectors from Level 1 to Level 3, backed by many years of experience."
    },
    {
      icon: "ri-sound-module-line",
      title: "Environmental Impact Management",
      description: "Identification and evaluation of construction activities with potential to release hazardous substances, managing noise and dust impacts on project performance and public domains."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Comprehensive Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            HP Inc. provides complete occupational health and safety consulting services for heavy civil, industrial, and construction projects
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg mb-4">
                <i className={`${service.icon} text-2xl text-orange-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-blue-50 rounded-lg p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-blue-800 mb-4">Specialized Expertise</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              <div>
                <h4 className="font-semibold text-blue-700 mb-2">Safety Training & Consulting</h4>
                <p className="text-gray-700">We train safety staff consultants and perform construction safety inspections to ensure compliance with OSHA, state, local, and government agencies, as well as clients' internal safety and health requirements.</p>
              </div>
              <div>
                <h4 className="font-semibold text-blue-700 mb-2">Industrial Hygiene Services</h4>
                <p className="text-gray-700">Our focus is to identify and evaluate construction activities with potential to release hazardous substances into the environment and manage issues such as noise and dust that can impact project performance.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverviewSection;
